import { ServiceNames, BaseParentDocumentService } from "./BaseDocumentService";
import { OpportunityAttachmentData } from "@/models/OpportunityAttachmentData";
import { NullableString } from "@/code/Types";

export class OpportunityAttachmentService extends BaseParentDocumentService<
  OpportunityAttachmentData
> {
  serviceName = ServiceNames.OpportunityAttachment;

  async downloadFile(id: NullableString, fileName: string): Promise<File> {
    const results = await this.client.get<File>(
      `/api/${this.serviceName}/downloadPLDMFile/${id}/${fileName}`,
      { responseType: "blob" }
    );
    return results.data;
  }


}
